import { useQuery } from "@tanstack/react-query";
import { qk } from "../../lib/queryKeys";
import { getJson } from "../../lib/http";
import { useCompaniesStore } from "../../store/admin/companiesStore";
import type { Geofence } from "../../store/admin/geofencesStore";

export interface GeofenceListParams {
  page?: number;
  limit?: number;
  status?: string;
  type?: string;
  shape?: string;
  search?: string;
}

interface ListMeta {
  error: string | null;
  count: number;
  status: number;
  currentPage: number;
  totalPages: number;
  totalItems: number;
  url: string;
}

export interface GeofenceListResult {
  data: Geofence[];
  meta?: ListMeta;
}

function buildParams(params: GeofenceListParams): Record<string, string | number> {
  const out: Record<string, string | number> = {
    page: params.page ?? 1,
    limit: params.limit ?? 6,
  };
  if (params.status && params.status !== "all") out.status = params.status;
  if (params.type && params.type !== "all") out.type = params.type;
  if (params.shape && params.shape !== "all") out.shape = params.shape;
  if (params.search) out.search = params.search;
  return out;
}

export function useGeofencesList(
  params: GeofenceListParams = {},
  options: { enabled?: boolean } = {},
) {
  const companyId = useCompaniesStore((s) => s.companyId);
  return useQuery({
    queryKey: qk.geofences.list(companyId, params),
    queryFn: ({ signal }) =>
      getJson<GeofenceListResult>("/geofenceList", buildParams(params), {
        signal,
      }).then((body) => ({ data: body.data ?? [], meta: body.meta })),
    enabled: options.enabled ?? true,
  });
}
